import I18nProvider from 'src/i18n/I18nProvider';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import { UserProvider } from '@hooks/useUser';
import { ErrorBoundaryProvider } from '@context/ErrorBoundary';
import { RouteUrlHistoryProvider } from '@context/RouteUrlHistory';
import SnackbarProvider from '@context/SnackbarNotifications/SnackbarNotifications';
import { SnackbarQueue } from '@context/SnackbarNotifications/SnackbarQueue';
import { TourProvider } from '@context/TourContext';
import { RemoteConfigProvider } from '@lib/remoteConfig';

interface AppContextProviderProps {
  children: React.ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  return (
    <ErrorBoundaryProvider>
      <UserProvider>
        <RemoteConfigProvider>
          <KeyboardDetectionProvider>
            <RouteUrlHistoryProvider>
              <I18nProvider>
                <TourProvider>
                  <SnackbarProvider>
                    {children}
                    <SnackbarQueue />
                  </SnackbarProvider>
                </TourProvider>
              </I18nProvider>
            </RouteUrlHistoryProvider>
          </KeyboardDetectionProvider>
        </RemoteConfigProvider>
      </UserProvider>
    </ErrorBoundaryProvider>
  );
};

export default AppContextProvider;
